// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NYe2","footer":"styles_footer__2-I2B"};